import script from "./AboutUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=339f648a&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339f648a"]])

export default __exports__